import { render } from "./EcosystemSection.vue?vue&type=template&id=45d501f7"
import script from "./EcosystemSection.vue?vue&type=script&lang=js"
export * from "./EcosystemSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__